import * as authentication from '@wix/auto_sdk_identity_authentication';
import * as recovery from '@wix/auto_sdk_identity_recovery';
import * as verification from '@wix/auto_sdk_identity_verification';
import * as oauth from '@wix/auto_sdk_identity_oauth';

export { authentication, recovery, verification, oauth };
